import type { UpdatePlanResponse } from '@vy/api-definition';
import { UpdatePlanResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';
import type { UpdatePlanRequest } from './use-update-plan-types/update-plan-request';
import { invalidatePlansQueries } from '../../../utils/query-invalidation';

export function useUpdatePlan(options?: UseMutationOptions<UpdatePlanResponse, unknown, UpdatePlanRequest>) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (updatePlanRequest) => {
      const api = getPrivateApi();
      const updatePlanResponse = await api.updatePlan(updatePlanRequest);

      return UpdatePlanResponseSchema.parse(updatePlanResponse);
    },
    onSuccess: async (response) => {
      await Promise.all([
        queryClient.invalidateQueries(queryKeys.plans(response.plan.id)),
        invalidatePlansQueries(queryClient),
      ]);
    },
    ...options,
  });
}
